export const sectionTitle = 'Statistics';